import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import { Space } from 'antd';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const privacyPolicyUrl = require('./privacy_e_cookie_policy.pdf');

const StyledFooterFlexRow = styled(FlexRow)`
  a {
    color: #fff;
    &:hover {
      color: #fff;
      /* text-decoration: underline; */
      border-bottom: 1px solid #fff;
    }
  }
`;

export interface FooterFrontPolicyRowProps {}

/**
 * Linea finale del Footer delle pagine pubbliche
 */
export function FooterFrontPolicyRow(props: FooterFrontPolicyRowProps) {
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  const rowTitle = t(
    'footer.static-text',
    'MiC - Direzione Generale Risorse Umane e Organizzazione',
  );

  const declarationText = t(
    'footer.policy.accessibility-declaration-text',
    'Dichiarazione di accessibilità',
  );

  const linkBlock = (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      size={isMobile ? 0 : 'large'}
    >
      {isMobile && <span>{rowTitle}</span>}
      {/* <a
        href="https://form.agid.gov.it/view/95d54a21-0152-4645-8b3f-f3800d835bb6/"
        target="_blank"
        rel="noreferrer"
      >
        {declarationText}
      </a> */}
      <a href={privacyPolicyUrl} target="_blank" rel="noreferrer">
        {t(
          'footer.policy.privacy-cookie-policy-text',
          'Privacy e cookie policy',
        )}
      </a>
    </Space>
  );

  return (
    <StyledFooterFlexRow right={!isMobile ? linkBlock : undefined}>
      {!isMobile ? <span>{rowTitle}</span> : linkBlock}
    </StyledFooterFlexRow>
  );
}
